import React from "react";

import { Div } from "components/Base";
import Actions from "./Actions";

import css from "./styles.scss";

const RowFile = ({ file, viaPortal }) => {
  return (
    <>
      <Div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
          ...(viaPortal ? { gap: "8px", alignItems: "flex-start" } : {})
        }}
        className={css.flex__container}
      >
        <Div
          style={{
            // width: "30%",
            fontStyle: "normal",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "17px"
          }}
        >
          {file.filename}
        </Div>
        <Actions file={file} uploadId={file.uploadId} />
      </Div>
      <Div
        style={{
          // width: "30%",
          fontStyle: "italic",
          fontWeight: "400",
          fontSize: "10px",
          lineHeight: "17px"
        }}
      >
        {file.type && (
          <span>
            Will be added as{" "}
            {file.version ? "a new version of an existing file" : "a new file"}.
          </span>
        )}
      </Div>
    </>
  );
};

export default RowFile;
